import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { staffQueryKeys } from "./staffQueryKeys";

export function useStaffEdit({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      staffId,
      patchedFields,
    }: {
      staffId: string;
      patchedFields: { [k: string]: any };
    }) => {
      if (patchedFields["picture"] && patchedFields["picture"].blob) {
        await api.staffApi.updatePicture(staffId, patchedFields["picture"]);
      }

      delete patchedFields["picture"];
      await api.staffApi.update(staffId, patchedFields);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: staffQueryKeys.all() });
    },
  });
}
